export enum ThresholdType {
    'comfort',
    'heatmap'
}